import { render, staticRenderFns } from "./OrganizationBranchWorkShift.vue?vue&type=template&id=b8981f1c&scoped=true"
import script from "./OrganizationBranchWorkShift.vue?vue&type=script&lang=js"
export * from "./OrganizationBranchWorkShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8981f1c",
  null
  
)

export default component.exports